const { createSlice, createAsyncThunk, createDraftSafeSelector } = require("@reduxjs/toolkit");
import axios from "axios";
import Axios from "axios";
import { FS } from "../other/constant";

const client = Axios.create({
  baseURL: "https://scoringapi.trava.finance/nftdashboard",
});

export const fetchJwtFromRefreshToken = createAsyncThunk(
  "profileSlice/fetchJwtFromRefreshToken",
  async (_, thunkAPI) => {
    const walletAddress = thunkAPI.getState().accountSlice.address;
    const res = await client
      .post("/v1/auth/refresh-token", {
        address: walletAddress,
        refreshToken: window.localStorage.getItem("refreshToken"),
      })
      .then((res) => res.data);
    if (res.success) {
      window.localStorage.setItem("jwtToken", res.result.jwt);
      return res.result.jwt;
    }
    window.localStorage.removeItem("refreshToken");
    throw new Error("Fail!");
  }
);

export const fetchNone = createAsyncThunk("profileSlice/fetchNonce", async (_, thunkAPI) => {
  const walletAddress = thunkAPI.getState().accountSlice.address;
  let nonce = "";
  try {
    const res = await client.get("/v1/wallet", { params: { wallet_address: walletAddress } }).then((res) => res.data);
    if (!res.success) {
      throw new Error("Fail");
    }
    nonce = res.result.nonce;
  } catch (error) {
    const res2 = await client.post("/v1/wallet", { wallet_address: walletAddress }).then((res) => res.data);
    nonce = res2.result.nonce;
  }
  return nonce;
});

export const fetchJWT = createAsyncThunk("profileSlice/fetchJWT", async ({ signature }, thunkAPI) => {
  const accountAddress = thunkAPI.getState().accountSlice.address;
  const res = await client.post("/v1/auth/login", { address: accountAddress, signature }).then((res) => res.data);
  if (res.success) {
    window.localStorage.setItem("jwtToken", res.result.jwt);
    window.localStorage.setItem("refreshToken", res.result.refreshToken);
    return res.result.jwt;
  }
  throw new Error("login failed");
});

export const fetchWalletTrading = createAsyncThunk("profileSlice/fetchWalletTrading", async (params, thunkAPI) => {
  const { rangeTime = "3m" } = params;
  const res = await client
    .get("/v1/wallet/nft/trade", {
      params: {
        range_time: rangeTime,
      },
      headers: {
        Authorization: window.localStorage.getItem("jwtToken"),
      },
    })
    .then((res) => res.data);
  let buy = res.result?.buyOnSale || {};
  buy = Object.keys(buy).map((key) => [parseInt(key) * 1000, parseInt(buy[key])]);
  let sell = res.result?.sellOnSale || {};
  sell = Object.keys(sell).map((key) => [parseInt(key) * 1000, parseInt(sell[key])]);
  let trading = res.result?.tradingVolumeLogs || {};
  trading = Object.keys(trading).map((key) => [parseInt(key) * 1000, parseInt(trading[key])]);
  return { buy, sell, trading };
});
export const fetchTravaHoldDistribution = createAsyncThunk(
  "profileSlice/fetchTravaHoldDistribution",
  async (params, thunkAPI) => {
    const { dataType } = params;
    const res = await client
      .get(`/v1/wallet/nft/${dataType}/bsc/holding`, {
        params: {},
        headers: {
          // Authorization:
          //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ3YWxsZXRfYWRkcmVzcyI6IjB4Yzg2NzQzMWVmYjNiNzc1YjcxMzIxOWViZDg1MmU3NzEyMTA3Y2UwZiIsImV4cCI6MTY1Mjg1MDAzOX0.WSnpD-HYRopER1uqlCs_9Z_aOsiDNcA3YrRmAyYSs5Q",
          Authorization: window.localStorage.getItem("jwtToken"),
        },
      })
      .then((res) => res.data);
    return {
      data: res.result,
      type: dataType,
    };
  }
);

const initialState = {
  fetchProfileDataStatus: FS.INITIAL,
  signature: "",
  nonce: "",
  jwt: "",
  walletTrading: undefined,
  travaDist: {
    trava_knight: null,
    trava_armoury: null,
  },
};

const profileSlice = createSlice({
  name: "profileSlice",
  initialState: initialState,
  reducers: {
    // updateSig: (state, action) => {
    //   state.signature = action.payload;
    // },
    // updateJwt: (state, action) => {
    //   state.jwt = action.payload;
    // },
  },
  extraReducers: {
    [fetchTravaHoldDistribution.fulfilled](state, action) {
      state.travaDist[action.payload.type] = action.payload.data;
    },
    [fetchWalletTrading.fulfilled](state, action) {
      state.walletTrading = action.payload;
    },
    [fetchWalletTrading.rejected](state) {
      state.fetchProfileDataStatus = FS.FAIL;
    },
    [fetchNone.fulfilled](state, action) {
      state.nonce = action.payload;
    },
    [fetchNone.rejected](state) {
      state.nonce = "";
    },
    [fetchJWT.fulfilled](state, action) {
      state.jwt = action.payload;
    },
    [fetchJWT.rejected](state) {
      state.jwt = "";
    },
  },
});

export default profileSlice.reducer;

// export const { updateSig, updateJwt } = profileSlice.actions;

export const selectProfileSlice = (state) => state.profileSlice;

export const selectTravaDist = createDraftSafeSelector(
  (state, dataType) => selectProfileSlice(state).travaDist[dataType],
  (travaDistData) => {
    if (!travaDistData) return null;
    let count = Object.keys(travaDistData).map((data) => ({
      name: data.charAt(0).toUpperCase() + data.slice(1),
      y: travaDistData[data].count,
    }));
    let value = Object.keys(travaDistData).map((data) => ({
      name: data.charAt(0).toUpperCase() + data.slice(1),
      y: travaDistData[data].value,
    }));
    return [value, count];
  }
);
